(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cd13-project-modification-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const initProjectRequest = (scope = document) => {
    const dialog = scope.querySelector?.('[data-project-request-dialog]') || (scope.matches?.('[data-project-request-dialog]') ? scope : null);
    if (!dialog || dialog.dataset.projectRequestReady === 'true') return;
    dialog.dataset.projectRequestReady = 'true';

    const productRoot = document.querySelector('[data-product-root]');
    const requestQuantity = dialog.querySelector('[data-project-request-quantity]');
    const submitButton = dialog.querySelector('[data-project-request-submit]');

    const syncQuantity = () => {
      const productQuantity = productRoot?.querySelector('input[name="quantity"]');
      if (!requestQuantity || !productQuantity) return;
      const quantity = Math.max(1, Number.parseInt(productQuantity.value, 10) || 1);
      requestQuantity.value = String(quantity);
    };

    const syncPageUrl = () => {
      const urlField = dialog.querySelector('[data-project-request-url]');
      if (urlField) urlField.value = window.location.href;
    };

    const openDialog = () => {
      syncQuantity();
      syncPageUrl();
      if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('cd13-project-request-open');
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('cd13-project-request-open');
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-project-request-open], a[href*="/pages/devis-projet"]');
      if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openDialog();
    });

    dialog.querySelector('[data-project-request-close]')?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('cancel', () => document.documentElement.classList.remove('cd13-project-request-open'));

    productRoot?.addEventListener('cd13:variant-change', (event) => {
      const variant = event.detail?.variant;
      if (!variant) return;

      const money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: productRoot.dataset.currency || 'EUR'
      }).format(Number(variant.price) / 100);

      const titleField = dialog.querySelector('[data-project-request-variant-title]');
      const idField = dialog.querySelector('[data-project-request-variant-id]');
      const skuField = dialog.querySelector('[data-project-request-variant-sku]');
      const priceField = dialog.querySelector('[data-project-request-variant-price]');
      const variantLabel = dialog.querySelector('[data-project-request-variant-label]');
      const priceLabel = dialog.querySelector('[data-project-request-price-label]');

      if (titleField) titleField.value = variant.title || '';
      if (idField) idField.value = variant.id || '';
      if (skuField) skuField.value = variant.sku || '';
      if (priceField) priceField.value = money;
      if (variantLabel) variantLabel.textContent = variant.title || '';
      if (priceLabel) priceLabel.textContent = money;
      syncPageUrl();
    });

    dialog.querySelector('form')?.addEventListener('submit', () => {
      syncQuantity();
      syncPageUrl();
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Envoi en cours…';
      }
    });

    if (dialog.querySelector('[data-project-request-success]')) openDialog();
  };

  document.addEventListener('DOMContentLoaded', () => initProjectRequest());
  document.addEventListener('shopify:section:load', (event) => initProjectRequest(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
